export default (value: string): string => (value || '').replace(/  +/g, ' ');
